interface CreditDisclaimerProps {
    secondApplicant?: boolean;
}

const CreditScoreDisclaimer = ({
    secondApplicant = false,
}: CreditDisclaimerProps) => {
    return (
        <div className='flex justify-center'>
            <p className='ml-1 font-bold text-sm'>
                This won&apos;t impact {secondApplicant ? 'their' : 'your'}{' '}
                credit file
            </p>
        </div>
    );
};

export default CreditScoreDisclaimer;
